var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShape = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.377 17.094a9 9 0 0 0 .529.529zm-.397-.46 7.376-7.377s-2.618.073-3.139.045S7.18 8.62 7.183 8.174s.622-.999 1.29-1.055c.669-.056 4.233-.117 4.233-.117s.84-.178 1.66.646c.833.83.655 1.669.655 1.669s-.061 3.564-.117 4.232-.608 1.288-1.055 1.29-1.1-.512-1.128-1.033.045-3.139.045-3.139L5.392 18.04A9.001 9.001 0 0 0 17.364 4.636 9 9 0 0 0 3.98 16.633m-.758 2.144c-4.296-4.296-4.296-11.26 0-15.556s11.26-4.296 15.556 0 4.296 11.26 0 15.556-11.26 4.296-15.556 0"
})));
export default SvgShape;